import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import {
    ContainerInner,
    ContainerSection,
} from '@components/_global/GlobalStyle/Global.styled';
import { ButtonIconText } from '@components/_universal/ButtonIconText/ButtonIconText';
import { IconWrapper } from '@components/_universal/ButtonIconText/ButtonIconText.styled';

import { breakpoints } from '@shared/constants';

export const ButtonWrapper = styled.div`
    margin-left: 76px;

    @media (max-width: ${breakpoints.md}px) {
        bottom: 60px;
        margin-top: 0;
        position: fixed;
        right: 45px;
        z-index: 9;

        ${IconWrapper} {
            margin-left: 0;
        }
    }
`;

export const ButtonIconTextElement = styled(ButtonIconText)`
    padding: 0;
`;

export const ButtonTextWrapper = styled.span`
    @media (max-width: ${breakpoints.md}px) {
        display: none;
    }
`;

export const StyledContainerSection = styled(ContainerSection)`
    align-items: center;
    display: flex;
    justify-content: flex-end;
`;

export const ReportID = styled(Typography.TextH2_28_44)`
    margin-bottom: 0;
`;

export const ReportStatus = styled.div(
    ({ theme: { fontSize, palette } }) => css`
        background: ${palette.neutral.gray};
        font-size: ${fontSize['14']}px;
        border-radius: 10px;
        display: flex;
        padding: 5px 20px;
    `,
);

export const Status = styled.div(
    ({ theme: { fontWeight } }) => css`
        font-weight: ${fontWeight.bold};
        padding-left: 8px;
    `,
);

export const ReportWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 24px;

    @media (max-width: ${breakpoints.md}px) {
        flex-direction: column;
    }
`;

export const ReportMessagesBox = styled.div(
    ({ theme: { palette, radius } }) => css`
        background: ${palette.tertiary.background};
        border-radius: ${radius[8]}px;
        display: flex;
        flex-direction: column;
        flex: 2;
        padding: 55px 120px 55px 50px;

        @media (max-width: ${breakpoints.md}px) {
            padding: 25px;
        }
    `,
);

export const QuestionMessage = styled(Typography.TextBody_16_24)(
    ({ theme: { palette } }) => css`
        background: ${palette.tertiary.background};
        display: flex;
        margin-bottom: 16px;
        padding-left: 16px;
        position: relative;
        word-break: break-word;

        &:before {
            background: ${palette.text.assistive};
            content: '';
            height: 20px;
            left: 0;
            position: absolute;
            top: 3px;
            width: 1px;
        }
    `,
);

export const AnswerMessage = styled(Typography.TextBody_16_24)(
    ({ theme: { fontWeight, palette } }) => css`
        background: ${palette.tertiary.background};
        display: flex;
        flex: 2;
        font-weight: ${fontWeight.bold};
        margin-bottom: 16px;
        padding-left: 16px;
        word-break: break-word;
    `,
);

export const ReportUploadFiles = styled.div(
    ({ theme: { palette, radius } }) => css`
        background: ${palette.tertiary.background};
        border-radius: ${radius[8]}px;
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-left: 30px;
        padding: 55px 50px;

        @media (max-width: ${breakpoints.md}px) {
            margin: 30px 0 0 0;
            padding: 25px;
        }
    `,
);

export const FileName = styled.div(
    ({ theme: { palette } }) => css`
        color: ${palette.tertiary.default};
        flex: 1;
        overflow: hidden;
        padding: 0 10px;
        text-overflow: ellipsis;
        white-space: nowrap;
    `,
);

export const FileSize = styled.div(
    ({ theme: { palette } }) => css`
        color: ${palette.text.assistive};
        min-width: 80px;
        white-space: nowrap;
        text-align: right;
    `,
);

export const UploadFile = styled.a`
    align-items: center;
    display: flex;
    margin-bottom: 16px;
    max-width: 280px;
    text-decoration: none;
    cursor: pointer;
`;

export const StyledContainerInner = styled(ContainerInner)`
    align-items: center;
    @media (max-width: ${breakpoints.md}px) {
        flex-direction: row;
    }
`;

export const EmptyFileListInfo = styled(Typography.TextBody_16_24)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.assistive};
        line-height: 28px;
    `,
);

export const HeaderText = styled(Typography.TextH4_20_28)`
    margin-bottom: 20px;
`;
